import { useEffect, useState } from "react";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { api, API_BASE } from "@/lib/api";
import { useCurrency } from "@/lib/currency";
import { Link } from "react-router-dom";
import StatusBadge from "@/components/StatusBadge";
import { FileText, BedDouble, Car } from "lucide-react";

export default function MyBookings() {
  const { fmt } = useCurrency();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/bookings").then((r) => setItems(r.data)); }, []);

  const downloadContract = async (b) => {
    const token = localStorage.getItem("mbk_token");
    const res = await fetch(`${API_BASE}/bookings/${b.id}/contract.pdf`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `contrat-${b.reference}.pdf`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      <SiteHeader />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-16">
        <h1 className="font-display text-3xl font-black text-[#0a1e3f]">Mes réservations</h1>
        <p className="text-sm text-gray-500 mt-1">Consultez, téléchargez ou imprimez vos contrats à tout moment.</p>
        <div className="mt-8 space-y-4">
          {items.length === 0 ? (
            <div className="bg-white rounded-2xl p-12 text-center border border-dashed border-gray-200">Aucune réservation pour le moment.</div>
          ) : items.map((b) => {
            const isLodging = b.resource_type === "lodging";
            const snap = isLodging ? b.lodging_snapshot : b.vehicle_snapshot;
            const Icon = isLodging ? BedDouble : Car;
            const canDownload = b.payment_status === "deposit_paid" || b.payment_status === "paid";
            const awaitingValidation = b.payment_status === "payment_received" || b.payment_status === "payment_received_full";
            return (
              <div key={b.id} data-testid={`my-booking-${b.id}`} className="bg-white rounded-2xl p-5 border border-gray-100 mbk-card-shadow">
                <div className="flex items-center justify-between flex-wrap gap-3">
                  <div className="flex items-center gap-4 flex-1 min-w-0">
                    <img src={snap?.photo || ""} alt="" className="h-16 w-24 object-cover rounded-xl bg-gray-100 flex-shrink-0" />
                    <div className="min-w-0">
                      <div className="text-xs uppercase tracking-widest text-gray-500 font-bold flex items-center gap-1"><Icon className="h-3 w-3" /> {b.reference}</div>
                      <div className="font-semibold text-[#0a1e3f] truncate">{isLodging ? snap?.name : `${snap?.brand || ""} ${snap?.model || ""}`}</div>
                      <div className="text-xs text-gray-500">Du {b.start_date} au {b.end_date} · {b.agency_snapshot?.name}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-black text-[#0a1e3f]">{fmt(b.pricing?.subtotal)}</div>
                    <div className="mt-1"><StatusBadge status={b.status} /></div>
                  </div>
                </div>
                {awaitingValidation && (
                  <div className="mt-3 p-3 rounded-xl bg-amber-50 border border-amber-200 text-xs text-amber-900" data-testid={`booking-awaiting-${b.id}`}>
                    <b>Paiement bien reçu — en attente de vérification MOBIKAR.</b><br/>
                    Dès validation des fonds, votre contrat de location vous sera envoyé automatiquement par email.
                  </div>
                )}
                <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-4 gap-2 flex-wrap">
                  <Link to={`/confirmation/${b.id}`} data-testid={`view-booking-${b.id}`} className="text-sm font-semibold text-[#0e7a3f] hover:underline">Voir le détail →</Link>
                  {canDownload && (
                    <button data-testid={`download-contract-${b.id}`} onClick={() => downloadContract(b)} className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-[#0a1e3f] text-white text-xs font-bold hover:opacity-90">
                      <FileText className="h-3.5 w-3.5" /> Télécharger le contrat
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
